import React, { useState } from "react";
import styled from "styled-components";
import { defineMessages } from "react-intl";
import { FormattedMessage } from "../../../components/FormattedMessage";
import { TrMetricsService } from "../../../services/TrMetricsService";
import {
  COVID_MODAL_OPENED_EVENT_NAME,
  COVID_BANNER_DISMISSED_EVENT_NAME,
} from "../../../config/metricsEventConfig";
import { ContactlessModal } from "./StyledContactlessBanner/ContactlessModal";

const messages = defineMessages({
  healthyCommunity: {
    id: "shared.react.components.StyledContactlessBanner.healthyCommunity",
    defaultMessage: "See our safety standards for COVID-19 ",
  },
  learnMore: {
    id: "shared.react.components.StyledContactlessBanner.learnMore",
    defaultMessage: "Learn more",
  },
});

export function StyledContactlessBanner({
  // isModalOpenInitialState is used in test to force the modal open.
  isModalOpenInitialState = false,
  additionalMetrics = {},
}) {
  const [showBanner, setShowBanner] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(isModalOpenInitialState);

  const onLearnMoreButtonClicked = () => {
    TrMetricsService.fire(COVID_MODAL_OPENED_EVENT_NAME, additionalMetrics);
    setIsModalOpen(true);
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };
  const hideBanner = () => {
    TrMetricsService.fire(COVID_BANNER_DISMISSED_EVENT_NAME, additionalMetrics);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <>
      <ContactlessModal isOpen={isModalOpen} hideModal={hideModal} />
      <ContactlessBannerContainer>
        <ContactlessBannerInner>
          <ContactlessBannerTextContainer>
            <ContactlessBannerHeader>
              <FormattedMessage message={messages.healthyCommunity} />
            </ContactlessBannerHeader>
            <ContactlessBannerButton
              data-test-id="ContactlessBannerButton"
              type="button"
              onClick={onLearnMoreButtonClicked}
            >
              <FormattedMessage message={messages.learnMore} />
            </ContactlessBannerButton>
            <ContactlessBannerCloseButton
              className="contactless-banner-close btn-icon"
              type="button"
              title="Close"
              onClick={hideBanner}
            >
              <CloseIcon className="ss-lnr-cross2" />
            </ContactlessBannerCloseButton>
          </ContactlessBannerTextContainer>
        </ContactlessBannerInner>
      </ContactlessBannerContainer>
    </>
  );
}

export const ContactlessBannerCloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  padding: 0;
`;

const CloseIcon = styled.i`
  color: ${(props) => props.theme.color.bodyText};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
`;

const ContactlessBannerContainer = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.color.grayBorder};
`;

const ContactlessBannerInner = styled.div`
  background: ${(props) => props.theme.color.alternateRow};
  padding-left: ${(props) => props.theme.spacing.lg};
  padding-right: ${(props) => props.theme.spacing.lg};
  padding-top: ${(props) => props.theme.spacing.sm};
  padding-bottom: ${(props) => props.theme.spacing.sm};
  margin-left: auto;
  margin-right: auto;
  ${(props) => props.theme.breakpoints.tabletUp} {
    padding: ${(props) => props.theme.spacing.lg};
  }
`;

const ContactlessBannerTextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
  ${(props) => props.theme.breakpoints.tabletUp} {
    flex-direction: row;
    justify-content: center;
  }
`;

const ContactlessBannerHeader = styled.div`
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  font-size: ${(props) => props.theme.typography.typeScale[50]};
  ${(props) => props.theme.breakpoints.tabletUp} {
    font-size: ${(props) => props.theme.typography.typeScale[200]};
  }
  margin-right: ${(props) => props.theme.spacing.md};
  color: ${(props) => props.theme.color.textLabelValue};
`;

export const ContactlessBannerButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  font-size: ${(props) => props.theme.typography.typeScale[50]};
  ${(props) => props.theme.breakpoints.tabletUp} {
    font-size: ${(props) => props.theme.typography.typeScale[200]};
  }
  text-decoration: underline;
  color: ${(props) => props.theme.color.bodyText};

  cursor: pointer;

  &:hover,
  &:active {
    color: ${(props) => props.theme.color.linkHover};
  }
`;
